import { useMemoizedFn } from 'ahooks';
import React, { useRef } from 'react';
import { Upload as TUpload } from 'tdesign-react';
import { round } from 'lodash';
import { getToken } from '@/utils/storage';

export default function Upload({ data, ...others }) {
  const uploadRef = useRef(null);

  // 上传文件，ajax pure js， onProgress
  const requestMethod = useMemoizedFn(async (file) => {
    const formData = new FormData();
    formData.append('file', file.raw);
    // 组装data参数
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const value = data[key];
        formData.append(key, value);
      }
    }

    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/exe_flow_service/fileUpload');
    xhr.setRequestHeader('X-Handle-Admin-Token', getToken());
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percent = round((event.loaded / event.total) * 100, 1);
        uploadRef.current.uploadFilePercent({ file, percent });
      }
    };
    return new Promise((resolve) => {
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve({
            status: 'success',
          });
        } else {
          resolve({
            status: 'fail',
            error: '上传失败',
          });
        }
      };
      xhr.onerror = () => {
        resolve({
          status: 'fail',
          error: '上传失败',
        });
      };
      xhr.send(formData);
    });
  });

  return (
    <TUpload
      ref={uploadRef}
      requestMethod={requestMethod}
      allowUploadDuplicateFile
      useMockProgress={false}
      {...others}
    />
  );
}
